import { WebsiteBlockTextAndMediaDisplayItem, WebsitePageDisplayItem } from "@sb/library/data-models";

export const pageNotFoundID = "pageNotFound_404";

export function CreateDefaultPageNotFoundPage(homepageTitle: string): WebsitePageDisplayItem {
    return new WebsitePageDisplayItem({
        ID: pageNotFoundID,
        Title: $localize`:@@WebsiteBuilderPageNotFound:Page Not Found`,
        WebsiteBlocks: [new WebsiteBlockTextAndMediaDisplayItem({
            Header: $localize`:@@WebsiteBuilderPageNotFound:Page Not Found`,
            Body: CreateDefaultPageNotFoundBody(homepageTitle),
        })]
    });
}

function CreateDefaultPageNotFoundBody(homepageTitle: string): string {
    const description = $localize`:@@WebsiteBuilderPageNotFoundDescription:Sorry, the page you requested could not be found. Check the URL and please try again.`;
    const returnToDescription = $localize`:@@WebsiteBuilderReturnToPageDescription:Return to ${homepageTitle}`;
    const htmlLink= "<br><br><b><a href=\"/\">" + returnToDescription + "</a></b>";

    return description + htmlLink;
}
